Retorna scripts ativos relacionados a chamadas que podem ser anexados a chamadas criadas pela API pública.

<ApiCodeExamples exampleId="scriptsList" />

<ApiResponseExamples exampleId="scriptsList" />

## Escopo obrigatório

- `scripts.read`

## Endpoints

- `GET /public/v1/scripts/`: lista paginada.
- `GET /public/v1/scripts/{id}/`: detalhe de um script.

O detalhe usa o mesmo formato de campo do item da lista.

## Query parameters

- `page` (`integer`, opcional): número da página.
- `page_size` (`integer`, opcional): quantidade de itens por página. Default `25`, máximo `100`.
- `search` (`string`, opcional): busca por nome e descrição.
- `ordering` (`string`, opcional): `name`, `event_type`, `script_type`, `updated_at`, ou os mesmos campos com prefixo `-`.
- `event_type` (`string`, opcional): filtra por evento.
- `script_type` (`string`, opcional): filtra por tipo de script.

## Campos de resposta

- `id` (`uuid`): id público do script. Scripts `pre_call` são enviados em `pre_call_script_id`; os demais scripts de chamada são enviados em `script_ids`.
- `name` (`string`): nome do script.
- `description` (`string`): descrição administrativa.
- `event_type` (`string`): evento de chamada que dispara o script.
- `script_type` (`string`): tipo de implementação do script.
- `updated_at` (`datetime`): data da última atualização.

## Referência de opções

- `event_type`: `pre_call`, `call_started`, `call_completed`, `call_failed`, `call_converted`, `call_optout`.
- `script_type`: `code`, `contact_z_message`.

O catálogo só expõe scripts `pre_call` ativos que possuem uma política pré-ligação configurada. Um `pre_call` não deve ser repetido em `script_ids`.

A API não expõe código, assets internos, histórico de execução ou configuração interna completa.

## Erros esperados

- `401 Unauthorized`: token inválido, expirado, revogado, ausente ou bloqueado por IP.
- `403 Forbidden`: a credencial não possui `scripts.read`.
- `404 Not Found`: o id do detalhe não está disponível para a organização.
- `429 Too Many Requests`: rate limit da credencial excedido.
